<template>
  <TsNuxtCard
      append-class="bg-white overflow-visible border-[#DEEFFF]"
      no-shadow
  >
    <TsImage
        class="mx-auto mb-4"
        src="/images/no-product.png"
        width="216"
        height="120"
        loading="lazy"
    />
    <TsTypography append-class="mb-4 text-[20px]" align="center">
      {{useTranslation("noItems","Er staan geen producten in je kluslijst. Blader door de producten en voeg toe wat je nodig hebt.")}}
    </TsTypography>
    <TsButton
        append-class="mx-auto block"
        :label="useTranslation('continueShopping', 'Ga door met winkelen')"
        size="sm"
        @click="navigateTo('/')"
    />
  </TsNuxtCard>
</template>

<script setup>

const TsNuxtCard = defineAsyncComponent(
    () => import('~/components/organisms/TsNuxtCard.vue')
);
</script>
